import { render } from "./DeviceStatusComponent.vue?vue&type=template&id=47d79d5f&scoped=true"
import script from "./DeviceStatusComponent.vue?vue&type=script&lang=js"
export * from "./DeviceStatusComponent.vue?vue&type=script&lang=js"

import "./DeviceStatusComponent.vue?vue&type=style&index=0&id=47d79d5f&scoped=true&lang=scss"

import exportComponent from "/Users/dmitriy-pc/Projects/ds-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47d79d5f"]])

export default __exports__